import { useBrandRegionCode } from "core/hooks/useBrandRegionCode";
import { getBrand } from "core/utils/getBrand";
import { useCallback } from "react";

export function useDmsDocumentHref(
  fileId?: string | null | undefined,
  fileName?: string | null | undefined,
  documentLink?: string | null | undefined,
  contentDisposition: "attachment" | "inline" = "attachment"
) {
  const getDmsDocumentHref = useGetDmsDocumentHref();
  if (documentLink) {
    return documentLink;
  }
  if (!fileName || !fileId) {
    return "";
  }
  return getDmsDocumentHref(fileId, fileName, contentDisposition);
}

export function useGetDmsDocumentHref() {
  const regionCode = useBrandRegionCode();
  const { brandCode } = getBrand();
  return useCallback(
    (
      fileId: string,
      fileName: string,
      contentDisposition: "attachment" | "inline" = "attachment"
    ) => {
      const searchParams = new URLSearchParams();
      searchParams.set("fileId", fileId);
      searchParams.set("regionCode", regionCode);
      searchParams.set("brandCode", brandCode!);
      searchParams.set("contentDisposition", contentDisposition);
      return `/api/dms-node/${encodeURIComponent(fileName)}?${searchParams.toString()}`;
    },
    [brandCode, regionCode]
  );
}
